import React from 'react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function Value() {
  const handleCheckoutClick = () => {
    trackInitiateCheckout();
  };
  return <section className="py-[60px] px-5 bg-brand-dark" data-id="element-346">
      <div className="max-w-[860px] mx-auto" data-id="element-347">
        <h2 className="text-[clamp(22px,4vw,36px)] font-black text-white mb-3 text-center" data-id="element-348">
          Lo Que Vale vs. Lo Que Pagas
        </h2>

        <table className="w-full border-collapse max-w-[560px] mx-auto mb-8 rounded-xl overflow-hidden" data-id="element-349">
          <tbody data-id="element-350">
            <tr data-id="element-351">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-352">
                eBook completo — 13 capítulos
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-brand-green font-bold text-right" data-id="element-353">
                $27
              </td>
            </tr>
            <tr data-id="element-354">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-355">
                Plan de 21 días — tabla completa
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-brand-green font-bold text-right" data-id="element-356">
                $17
              </td>
            </tr>
            <tr data-id="element-357">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-358">
                5 Scripts de negociación
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-brand-green font-bold text-right" data-id="element-359">
                $17
              </td>
            </tr>
            <tr data-id="element-360">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-361">
                4 Mini-plantillas LITE
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-brand-green font-bold text-right" data-id="element-362">
                $10
              </td>
            </tr>
            <tr data-id="element-363">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-364">
                3 Ejemplos ya llenos
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-brand-green font-bold text-right" data-id="element-365">
                $10
              </td>
            </tr>
            <tr className="bg-brand-yellow/10 font-black text-brand-yellow text-base" data-id="element-366">
              <td className="p-3 px-4.5 border-t border-brand-border" data-id="element-367">
                VALOR TOTAL
              </td>
              <td className="p-3 px-4.5 border-t border-brand-border text-right" data-id="element-368">
                $81
              </td>
            </tr>
          </tbody>
        </table>

        <div className="bg-gradient-to-br from-brand-dark2 to-brand-dark3 border-2 border-brand-red rounded-[20px] p-10 text-center max-w-[560px] mx-auto shadow-[0_0_50px_rgba(230,57,70,0.15)] relative sm:p-8 sm:px-5" data-id="element-369">
          <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-brand-yellow text-brand-dark text-[11px] font-black px-4.5 py-1 rounded-full whitespace-nowrap" data-id="element-370">
            ⚡ PRODUCTO PREMIUM ⚡
          </div>

          <div className="text-lg text-brand-gray line-through mb-1" data-id="element-371">
            Valor real: $81.00
          </div>
          <div className="text-[clamp(52px,10vw,80px)] font-black text-brand-yellow leading-none mb-2" data-id="element-372">
            $6.39
          </div>

          <div className="inline-block bg-brand-green/15 border border-brand-green/40 text-brand-green text-sm font-bold px-4.5 py-1.5 rounded-full mb-6" data-id="element-373">
            ✅ Ahorras $74.61 — Hoy solamente
          </div>

          <div className="flex flex-col gap-2.5 text-left mb-7" data-id="element-374">
            <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-375">
              <span className="shrink-0" data-id="element-376">✅</span> eBook completo · 13 capítulos
              · Método 4C
            </div>
            <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-377">
              <span className="shrink-0" data-id="element-378">✅</span> Plan de 21 días · acción día
              por día
            </div>
            <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-379">
              <span className="shrink-0" data-id="element-380">✅</span> 5 Scripts de negociación ·
              listos para llamar hoy
            </div>
            <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-381">
              <span className="shrink-0" data-id="element-382">✅</span> 4 Mini-plantillas LITE · para
              papel o teléfono
            </div>
            <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-383">
              <span className="shrink-0" data-id="element-384">✅</span> 3 Ejemplos ya llenos · casos
              reales
            </div>
            <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-385">
              <span className="shrink-0" data-id="element-386">✅</span> Garantía 30 días · sin riesgo
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 text-[13px] text-brand-yellow font-bold mb-4 before:content-['⚡']" data-id="element-387">
            Producto Premium · Descarga Inmediata · Acceso Instantáneo
          </div>

          <a href="https://www.betterdailyguides.com/cart/51869771923758:1" onClick={handleCheckoutClick} className="btn-buy-main block w-full text-white no-underline text-[clamp(16px,3vw,22px)] font-black py-5 px-7 rounded-xl uppercase tracking-[1px] transition-all duration-300 shadow-[0_8px_30px_rgba(230,57,70,0.5)] text-center cursor-pointer border-none hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(230,57,70,0.6)]" data-id="element-388">
            🔥 SÍ — QUIERO EL SISTEMA POR $6.39
            <span className="block text-xs font-normal opacity-85 mt-1 normal-case tracking-normal" data-id="element-389">
              Pago seguro · PDF en segundos · Garantía 30 días
            </span>
          </a>

          <div className="flex justify-center gap-5 flex-wrap mt-4 text-xs text-brand-gray" data-id="element-390">
            <span className="flex items-center gap-1" data-id="element-391">🔒 SSL Seguro</span>
            <span className="flex items-center gap-1" data-id="element-392">
              📱 Cualquier dispositivo
            </span>
            <span className="flex items-center gap-1" data-id="element-393">⚡ Acceso inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}